import { useNavigate } from "@tanstack/react-router";

import { Button } from "@/components/ui/Button";
import { logout, pb } from "@/lib/pb";
import { PathBar } from "./PathBar";

export function Header() {
  const navigate = useNavigate();

  const user = pb.authStore.model;
  const email = (user as { email?: string } | null)?.email ?? "guest";

  async function handleLogout() {
    await logout();
    navigate({ to: "/login" });
  }

  return (
    <header className="h-14 border-b border-border bg-gradient-to-b from-bg-elev/50 to-bg-elev/20 backdrop-blur-md px-6 flex items-center justify-between relative">
      <span className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-violet/40 to-transparent" />
      <PathBar />
      <div className="flex items-center gap-4">
        <span className="text-xs text-muted font-mono">{email}</span>
        <Button variant="ghost" onClick={handleLogout} className="px-3 py-1.5 text-xs">
          logout
        </Button>
      </div>
    </header>
  );
}
